import { Injectable } from '@angular/core';
import { ApiClientService } from '../api-client.service';
import { Observable } from 'rxjs/Observable';
import { ApiResponseList } from '../../types/api-response/helpers';
import { IPassOnLogSettings } from '../../types/api-response/pass-on-log-settings';

@Injectable()
export class PassOnLogApiService {

    constructor(private api: ApiClientService) {}

    /**
     * Returns Pass On Log settings details
     */
    getSettings(): Observable<ApiResponseList<IPassOnLogSettings>> {
        return this.api.get('domainPassOnLog', '/v1/settings.json').map(
          res => res.json(),
          (error) => this.api.errorHandler(error, 'Failed to get Suite')
        );
    }
}



// WEBPACK FOOTER //
// /app/src/app/services/api/pass-on-log-api.service.ts